var map = {
	"./boost-your-post-for-increasing-sales.md": 94,
	"./difference-between-gatsbyjs-and-nextjs.md": 95,
	"./future-of-javascript.md": 96,
	"./how-to-choose-javascript-framework-for-project.md": 97,
	"./how-to-get-10k-instagram-followers.md": 98,
	"./installing-nodejs-on-your-device.md": 99,
	"./markdown-html-supported-blog.md": 100,
	"./popular-javascript-library-in-2020.md": 101,
	"./programmers-must-read-books.md": 102,
	"./think-out-of-the-box.md": 103,
	"./time-to-use-latest-technology-for-creating-a-website.md": 104,
	"./trending-designs-in-2020.md": 105,
	"./uiux-design-starter-with-adobe-xd.md": 106,
	"./web-automation-with-python-language.md": 107,
	"./what-nodejs-can-do.md": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;